export const prepareEmailHtml = (raw: string): string => {
  // 1.       Take only the body fragment ───────────────────────────────────
  const bodyMatch = /<body[^>]*>([\s\S]*?)<\/body>/i.exec(raw);
  const fragment = bodyMatch ? bodyMatch[1] : raw;

  // 2.       Let the browser “repair” broken nesting, then read back
  const tmp = document.implementation.createHTMLDocument('');
  tmp.body.innerHTML = fragment; // auto-closes orphan <div>, <font> …

  // 3.       Strip <img src="cid:*"> and 1×1 tracking pixels
  tmp.querySelectorAll('img').forEach(img => {
    const cid = img.src.startsWith('cid:');
    const tracker = img.width <= 1 && img.height <= 1;
    if (cid || tracker) img.remove();
  });

  // TODO - log the html if invalid
  return tmp.body.innerHTML;
};
